<script setup lang="ts">
import { computed, nextTick } from 'vue'

import { triggerApplyListFiltersEvent } from '@shared/event/events/list-filter'
import type { Filter } from '@storefront-satch/components/molecules/filter/types'
import { useUrlSearchParams } from '@vueuse/core'
import { useForm } from 'vee-validate'

const props = defineProps<{
  selectedFilter: Record<string, string[]>
  filter: Filter[]
}>()

const filter = computed(() => {
  return {
    price: props.filter.filter((f) => f.type === 'PRICE_RANGE')[0],
    rest: props.filter.filter((f) => f.type !== 'PRICE_RANGE'),
  }
})

const searchParams = useUrlSearchParams()

const { handleSubmit } = useForm({
  initialValues: {
    ...props.selectedFilter,
    'filter.v.price': [
      filter.value.price?.values?.[0]?.input?.price?.min ?? '',
      filter.value.price?.values?.[0]?.input?.price?.max ?? '',
    ],
  },
  keepValuesOnUnmount: true,
})

const PRICE_FILTER_NAME = 'filter.v.price'

const onSubmit = handleSubmit(async (values) => {
  await nextTick(() => {
    for (const [key, value] of Object.entries(values)) {
      if (
        key === PRICE_FILTER_NAME &&
        value[0] === filter.value.price?.values?.[0]?.input?.price?.min &&
        value[1] === filter.value.price?.values?.[0]?.input?.price?.max
      ) {
        continue
      }

      if (key === PRICE_FILTER_NAME) {
        searchParams[key] = value.join(',')
        continue
      }
      searchParams[key] = value
    }
  })

  triggerApplyListFiltersEvent({
    listFilters: values,
  })

  const url = new URL(globalThis.location.href)
  globalThis.location.assign(url)
})
</script>

<template>
  <form @submit.prevent="onSubmit">
    <slot />
  </form>
</template>
